<mat-form-field appearance="fill"
  [matTooltip]="tooltip"
  [matTooltipDisabled]="!tooltip"
  matTooltipPosition="above"
  matTooltipClass="sbm-tooltip">

  <mat-label>
    <app-required *ngIf="isRequired()"></app-required> {{label}}
  </mat-label>

  <span matPrefix *ngIf="isAmount">₹ &nbsp;</span>

  <input matInput *ngIf="!decimalInput"
    [type]="type && hide ? type : 'text'"
    [formControl]="control"
    [name]="name"
    [placeholder]="placeholder || ''"
    restrictTo
    [valType]="restrictedTo"
    [maxlength]="maxlength"
    (ngModelChange)="emitChange($event)"
    (blur)="emitBlurEvent($event.target.value)"
    (input)="toUpperCase ? $event.target.value = $event.target.value.toUpperCase() : null">

  <input matInput *ngIf="decimalInput"
    [formControl]="control"
    restrictDecimal
    [toDecimalPlaces]="decimalPlaces"
    [placeholder]="placeholder || ''"
    [maxlength]="maxlength"
    (ngModelChange)="emitChange($event)">

  <button mat-icon-button
    type="button"
    matSuffix
    (click)="hide = !hide"
    *ngIf="type === 'password'">
    <mat-icon class="viewToggle">
      {{ hide ? 'visibility' : 'visibility_off' }}
    </mat-icon>
  </button>

  <!-- ✅ SINGLE ERROR AT A TIME -->
  <ng-container *ngIf="control && control.invalid && (control.touched || control.dirty)"
    ngProjectAs="mat-error">

    <mat-error *ngIf="control.hasError('required')">
      {{label}} is <strong>required</strong>.
    </mat-error>

    <mat-error
      *ngIf="!control.hasError('required') && control.hasError('pattern')">
      {{ patternMsg ? patternMsg : label + ' is invalid' }}
    </mat-error>

    <mat-error
      *ngIf="!control.hasError('required')
          && !control.hasError('pattern')
          && control.hasError('min')">
      {{label}} cannot be less than
      <strong>{{control.errors?.min.min}}</strong>.
    </mat-error>

    <mat-error
      *ngIf="!control.hasError('required')
          && !control.hasError('pattern')
          && !control.hasError('min')
          && control.hasError('max')">
      {{label}} cannot be more than
      <strong>{{control.errors?.max.max}}</strong>.
    </mat-error>

    <mat-error
      *ngIf="!control.hasError('required')
          && !control.hasError('pattern')
          && !control.hasError('min')
          && !control.hasError('max')
          && control.hasError('minlength')">
      {{label}} must be at least
      {{control.errors?.minlength.requiredLength}}
      characters long.
    </mat-error>

    <mat-error *ngIf="control.hasError('equal')">
      {{label}} equal to
      <strong>{{control.errors?.equal.equal}}</strong>.
    </mat-error>

    <mat-error *ngIf="control.hasError('invalid')">
      {{errMsg ? errMsg : 'Invalid'}}
    </mat-error>

    <mat-error *ngIf="control.hasError('MatchPassword')">
      Password does not match.
    </mat-error>

  </ng-container>

  <mat-hint *ngIf="hint">
    <strong>{{hint}}</strong>
  </mat-hint>

</mat-form-field>
